import { React, useEffect, useState, useContext } from "react";
import { initialInvoice, initialLineItem } from "../data/initialData";
import EditableInput from "./EditableInput";
import { Row, Button, Col, Container, Alert, } from "react-bootstrap";
import Document from "./Document";
import Page from "./Page";
import View from "./View";
import Text from "./Text";
import DownloadPDF from './DownloadPDF'
import ExportCSV from './ExportCSV'
import EditableTextarea from './EditableTextarea'
import EditableSelect from './EditableSelect'
import ImageModal from "./AddReceipt";
import { FetchContext } from "../context/FetchContext";
import { AuthContext } from "../context/authContext";
import AlertMsg from "./PopUp";
import Confirm from "./Confirm";
import { pdf } from "@react-pdf/renderer";
import { use } from "react";
import { applyFixedFeeOffset } from "../utils/fixedFeeOffset";

const Invoice = ({ cons, data, pdfMode, onChange, btnSelect, editable, descripts, setLastAction, fixedFeeContracts }) => {
 
  const [itemDelete, setItemsToDelete] = useState([])
  const [locDelete, setLocsToDelete] = useState([])
  const auth = useContext(AuthContext);

  const [consult, setCons] = useState(cons)
  const [alertShow, setAlertShow] = useState(false)
  const [alertMsg, setAlertMsg] = useState('')
  const [alertTitle, setAlertTitle] = useState('')
  const [alertVari, setAlertVari] = useState('')
  const fetchContext = useContext(FetchContext);
  const [isLoading, setIsLoading] = useState(false)
  const [subTotal, setSubTotal] = useState();
  const [file, setFile] = useState([]);
  const [invoiceNumbers, setInvoiceNumbers] = useState([]);
  const [descriptions, setDescriptions] = useState([])
  const reportable = [
    { value: '', text: "Select" },
    { value: "Reportable", text: "Yes" },
    { value: "Non-Reportable", text: "No" }
  ]
  const [dupewarn, setDupeWarn] = useState(false)
  const [lineItems, setLineItems] = useState([]);
  const [invoice, setInvoice] = useState(data ? Object.assign({}, data) : Object.assign({}, initialInvoice));
  const [refresh, setRefresh] = useState(false)
  function checkForm(mode = "draft") {
    // Base requirements (for both Draft and Submit)
    const hasValidProductDetails = invoice.lineItems.every((lt) => {
      const pt = (lt?.ProductType ?? "").trim();
      const productTypeValid =
        pt.length > 2 && pt !== "Select Product or Service";

      // Determine whether detail is required by looking up `descripts` first,
      // falling back to previous Travel Fee / Per Diem logic if unspecified.
      let detailIsRequired;
      try {
        const match = descripts?.find(
          (d) =>
            ((d?.value ?? "").toString().trim().toLowerCase()) === pt.toLowerCase()
        );
        if (match && typeof match.required === "boolean") {
          detailIsRequired = !!match.required;
        } else {
          detailIsRequired =
            pt !== "Travel Fee" && !pt.toLowerCase().includes("per diem");
        }
      } catch (e) {
        detailIsRequired =
          pt !== "Travel Fee" && !pt.toLowerCase().includes("per diem");
      }

      const detailValid =
        !detailIsRequired || ((lt?.ProductDetail ?? "").trim().length > 2);

      return productTypeValid && detailValid;
    });

    const baseValid =
      Array.isArray(invoice.lineItems) &&
      invoice.lineItems.length >= 1 &&
      !!invoice.Reportable &&
      !!invoice.ConsultantInvoice &&
      !!invoice.StartDate &&
      !!invoice.EndDate &&
      hasValidProductDetails;

    if (!baseValid) return true; // invalid for both draft & submit

    if (mode === "submit") {
      // Must have a Location array with at least one entry
      const locArray = Array.isArray(invoice?.locations) ? invoice.locations : [];

      const allLocationsValid =
        locArray.length > 0 &&
        locArray.every(
          (loc) =>
            (loc?.city ?? "").trim().length > 0 &&
            (loc?.state ?? "").trim().length > 0
        );

      if (!allLocationsValid) return true; // invalid for submit
    }

    return false; // valid
  }

  function setInvoiceFunc() {

    setInvoice(() => data)
    setRefresh(true)
    setIsLoading(false)
    filtDescript()

  }
  // useEffect(() => {

  //   setRefresh(false)
  //   setInvoiceFunc()
  //   fetchInvoiceNumbers()

  // }, [refresh, isLoading]);
  useEffect(() => {
    if (refresh) {
      setIsLoading(true);
      setInvoiceFunc();
      filtDescript()
      fetchInvoiceNumbers();
      setRefresh(false);

    }
  }, [refresh]);

  useEffect(() => {
    // Clear duplicate warning for submitted/processed invoices
    if (!editable) {
      setDupeWarn(false);
    }
  }, [editable]);
  useEffect(() => {
    // console.log("descripts or invoice.consultantsAssignProjects changed");
    filtDescript();
  }, [invoice, descripts]);

  useEffect(() => {
    if (onChange) {
      onChange(invoice);
    }
  }, [onChange, invoice]);

  // Re-evaluate the fixed fee offset once contract data has loaded (covers opening an
  // existing draft that already has qualifying hours, not just live edits).
  useEffect(() => {
    if (Array.isArray(fixedFeeContracts) && fixedFeeContracts.length > 0) {
      setInvoice(prev => ({
        ...prev,
        lineItems: applyFixedFeeOffset(prev.lineItems || [], fixedFeeContracts, prev.StartDate)
      }));
    }
  }, [fixedFeeContracts]);

  useEffect(() => {
    let subTotal = 0;

    if (invoice.lineItems) {
      invoice.lineItems.forEach((lineItem) => {
        // console.log(lineItem)
        const quantityNumber = parseFloat(lineItem.quantity);
        const rateNumber = parseFloat(lineItem.rate);
        const amount = quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;
        subTotal += amount;
      });
    }
    subTotal = parseFloat(subTotal).toFixed(2)
    // console.log(subTotal);
    setSubTotal(subTotal);
    setInvoice(Object.assign(Object.assign({}, invoice), { subTotal }))
    // Only check for dupes if invoice is editable
    if (editable) {
      checkDupe(invoice)
    }
  }, [isLoading, invoice.lineItems, editable]);


  function filtDescript() {
    // console.log("filtDescript called")
    // console.log(descripts)

    if (Array.isArray(descripts) && Array.isArray(invoice.consultantsAssignProjects)) {
      // Get the bill types from the projects
      const allowedTypes = invoice.consultantsAssignProjects.map(
        proj => proj["ConsultInv | ConsultantsAssign_Projects::BillType"]
      );

      // console.log("allowedTypes", allowedTypes);

      // Define the two consultant types
      const consultantTypes = ["Consultant - Hourly", "Consultant - Daily"];

      // Keep everything except the opposite consultant type
      const filtered = descripts.filter(d => {
        if (consultantTypes.includes(d.value)) {
          // Keep it ONLY if it's one of the allowedTypes
          return allowedTypes.includes(d.value);
        }
        // Leave everything else alone
        return true;
      });

      setDescriptions(filtered);
      return filtered;
    }

    setDescriptions(descripts);
    return [];
  };


  const handleChange = (name, value) => {
    if (name !== 'lineItems') {
      const newInvoice = Object.assign({}, invoice);

      if (name === 'EndDate') {
        const start = invoice.StartDate;
        const endDate = new Date(value);

        if (!start || (new Date(start) <= endDate)) {
          newInvoice[name] = value;
        } else {
          newInvoice[name] = ''; // Reset to blank if invalid
        }
        setInvoice(newInvoice);

      } else if (name === 'StartDate') {
        const end = invoice.EndDate;
        const startDate = new Date(value);

        if (!end || (startDate <= new Date(end))) {
          newInvoice[name] = value;
        } else {
          newInvoice[name] = ''; // Reset to blank if invalid
        }
        newInvoice.lineItems = applyFixedFeeOffset(invoice.lineItems, fixedFeeContracts, newInvoice.StartDate);
        setInvoice(newInvoice);

      } else if (name === 'logoWidth' && typeof value === 'number') {
        newInvoice[name] = value;
        setInvoice(newInvoice);

      } else if (name !== 'logoWidth' && typeof value === 'string') {
        newInvoice[name] = value;
        setInvoice(newInvoice);
      }
    }
  };

  const handleProductLineChange = (index, name, value) => {
    // console.log(invoice);

    // helper: true only for Per Diem types (match by name)
    const isPerDiemType = (v = "") => /(^|\s)per\s*diem(\s|$)/i.test(v);

    const lineItems = invoice.lineItems.map((lineItem, i) => {
      if (i !== index) return Object.assign({}, lineItem);

      const newLineItem = Object.assign({}, lineItem);

      if (name === "ProductType") {
        newLineItem[name] = value;

        // defaults
        newLineItem.rate = "0.00";
        newLineItem.unit = "";

        // 1) Consultant logic (unchanged)
        if (
          Array.isArray(invoice.consultantsAssignProjects) &&
          value.includes("Consultant")
        ) {
          const match = invoice.consultantsAssignProjects.find(
            (proj) =>
              proj["ConsultInv | ConsultantsAssign_Projects::BillType"] === value
          );
          if (match) {
            newLineItem.rate = Number(
              match["ConsultInv | ConsultantsAssign_Projects::BillRate"]
            ).toFixed(2);
            newLineItem.unit =
              match["ConsultInv | ConsultantsAssign_Projects::BillType"] || "";
          }
        }
        // 2) ONLY assign from `descripts.price` when this is a Per Diem type
        else if (isPerDiemType(value) && Array.isArray(descripts)) {
          // exact match to the selected ProductType (covers both Per Diem variants)
          const d = descripts.find((x) => x?.value === value);
          if (d && (d.price ?? d.Price) != null) {
            const raw = String(d.price ?? d.Price);
            const num = parseFloat(raw.replace(/[^0-9.]/g, ""));
            if (!Number.isNaN(num)) newLineItem.rate = num.toFixed(3);
          }
          if (d?.unit) newLineItem.unit = d.unit;
        }
        // 3) For non-Consultant, non-Per Diem types: leave defaults ("0.00", "")
      }
      else if (name === "ProductDetail") {
        newLineItem[name] = value;
      }
      else if (name === "file") {
        if (value.length === 0) {
          newLineItem.base64Container = "";
          newLineItem.fileName = "";
        } else {
          newLineItem.base64Container = value[0].b64;
          newLineItem.fileName = value[0].fileName;
        }
      }
      else {
        let val = value.replace("$", "");
        if (
          val[val.length - 1] === "." ||
          (val[val.length - 1] === "0" && val.includes("."))
        ) {
          newLineItem[name] = val;
        } else {
          const n = parseFloat(val);
          newLineItem[name] = (n ? n : 0).toString();
        }
      }

      return newLineItem;
    });

    const finalLineItems = applyFixedFeeOffset(lineItems, fixedFeeContracts, invoice.StartDate);

    setInvoice(Object.assign(Object.assign({}, invoice), { lineItems: finalLineItems }));
  };

  const handleFormat = (index, name, value) => {
    // console.log("handleFormat")
    // console.log(index)
    // console.log(name)
    // console.log(value)

    if (editable) {
      let val = value.replace('$', '')
      const lineItems = invoice.lineItems.map((lineItem, i) => {
        if (name === 'rate' && i === index && val.length > 0) {
          // console.log(lineItem)
          const newLineItem = Object.assign({}, lineItem);


          newLineItem[name] = parseFloat(val).toFixed(2)

          return newLineItem;
        }
        return Object.assign({}, lineItem);
      });
      setInvoice(Object.assign(Object.assign({}, invoice), { lineItems }));
      // console.log(invoice)
    }
  };

  const handleRemoveLoc = (i, value) => {
    const locations = invoice.locations.filter((loc, index) => index !== i);
    setInvoice(Object.assign(Object.assign({}, invoice), { locations }))
    const delLoc = invoice.locations.filter((loc, index) => index === i);

    if (delLoc[0].recordID) {
      setLocsToDelete([...locDelete, delLoc[0].recordID])
    }

  };
  const handleRemove = (i) => {

    const lineItems = invoice.lineItems.filter((lineItem, index) => index !== i);
    const delItem = invoice.lineItems.filter((lineItem, index) => index === i);
    if (delItem[0].recordID) {
      setItemsToDelete([...itemDelete, delItem[0].recordID])
    }
    const finalLineItems = applyFixedFeeOffset(lineItems, fixedFeeContracts, invoice.StartDate);
    setLineItems(finalLineItems)
    setInvoice(Object.assign(Object.assign({}, invoice), { lineItems: finalLineItems }))
  };
  function handleAdd() {
    // console.log(invoice.lineItems)
    const lineItems = [...invoice.lineItems, initialInvoice.lineItems[0]];
    setInvoice(Object.assign(Object.assign({}, invoice), { lineItems }));

  };
  function handleLocationChange(index, name, value) {
    const locations = invoice.locations.map((loc, i) => {
      const newLoc = Object.assign({}, loc);;
      if (i === index) {
        newLoc[name] = value;

        return newLoc;
      }
      return loc;
    });
    setInvoice(Object.assign(Object.assign({}, invoice), { locations }));
  };

  function handleAddLoc() {
    const locations = [...invoice.locations, { "city": '', "state": '' }]
    setInvoice(Object.assign(Object.assign({}, invoice), { locations }))
  }
  const calculateAmount = (quantity, rate) => {
    const quantityNumber = parseFloat(quantity);
    const rateNumber = parseFloat(rate);
    const amount = quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;
    return amount.toFixed(2);
  };

  async function handleDraft(e) {
    // console.log("savedraft")
    e.preventDefault();
    // console.log(invoice)
    setIsLoading(true)
    try {
      await fetchContext.authAxios.post("/savedraft", { invoice, itemDelete, locDelete }).then((res) => {
        // console.log(res.data)
        if (res.data.message === 'Session Expired') {
          auth.logout()
        }
        if (res.data.message === 'Success') {
          setItemsToDelete([])
          setLocsToDelete([])
          setAlertMsg('Your invoice has succesfully saved.')
          setAlertTitle('Success!')
          setAlertVari('primary')
          setAlertShow(true)
          setTimeout(() => {
            setAlertShow(false)
          }, 3000);
          setIsLoading(true)
          setRefresh(true)

          window.location.reload(false)
        }
      });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setAlertMsg('There was an error saving your draft. Please try again.');
      setAlertTitle('Error');
      setAlertVari('danger');
      setAlertShow(true);
    }

  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    // console.log(invoice)
    try {
      await fetchContext.authAxios.post("/submitinvoice", { invoice, itemDelete, locDelete }).then((res) => {
        // console.log(res.data)
        if (res.data.message === 'Session Expired') {
          auth.logout()
        }
        if (res.data.message === 'Success') {
          setItemsToDelete([])
          setLocsToDelete([])
          setAlertMsg('Your invoice has succesfully saved.')
          setAlertTitle('Success!')
          setAlertVari('primary')
          setAlertShow(true)
          setTimeout(() => {
            setAlertShow(false)
          }, 3000);
          setIsLoading(true)
          setRefresh(true)
          window.location.reload(false)
        }
      });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setAlertMsg('There was an error submitting your invoice. Please try again.');
      setAlertTitle('Error');
      setAlertVari('danger');
      setAlertShow(true);
    }
  }
  function checkDupe(ie) {
    const result = Object.values(
      ie.lineItems
        .filter(v => (v?.ProductDetail ?? "").trim() !== "Consulting Fixed Fee Offset")
        .reduce((c, v) => {
          // Create a unique key from both ProductType and ProductDetail
          let productType = (v?.ProductType ?? "").trim().toLowerCase();
          let detail = (v?.ProductDetail ?? "").trim().toLowerCase();
          let k = `${productType}|${detail}`;

          // Only check for duplicates if both fields are not empty
          if (productType.length === 0 || detail.length === 0) return c;
          c[k] = c[k] || [];
          c[k].push(v);
          return c;
        }, {})
    ).reduce((c, v) => (v.length > 1 ? c.concat(v) : c), []);

    setDupeWarn(result.length > 0);
  }

  function isDetailRequired(productType) {
    // prefer explicit descriptor flag from `descripts` if available
    try {
      const pt = (productType || '').toString().trim();
      const match = descripts?.find(d => (d?.value ?? '').toString().trim().toLowerCase() === pt.toLowerCase());
      if (match && typeof match.required === 'boolean') {
        return match.required;
      }
    } catch (e) {
      // fall back to default logic on error
    }

 
  }

  const isReadOnly = ['Finalized', 'Locked', 'Processed'].includes(invoice.Status);
  const fetchInvoiceNumbers = async () => {
    if (!fetchContext || !fetchContext.authAxios) {
      // console.error("FetchContext or authAxios is undefined");
      return;
    }
    try {
      const response = await fetchContext.authAxios.get("/invoice-numbers");
      const data = response.data;
      setInvoiceNumbers(data);
    } catch (error) {
      console.error("Error fetching descriptions:", error);
    }
  };

  return (<>
    {isLoading ? (pdfMode ? (null) : (<h2>LOADING</h2>)) : (

      <>


        <Document pdfMode={pdfMode} className="app ">

          <Page className="invoice-wrapper pdfPadding" pdfMode={pdfMode}>
            <View className="flex" pdfMode={pdfMode}>
              <View className="w-50" pdfMode={pdfMode}>

                <Text className='invoiceLRI' pdfMode={pdfMode} value={consult.NameFirst + " " + consult.NameLast} >{consult.NameFirst + " " + consult.NameLast}</Text>
                <Text className='invoiceTxt' pdfMode={pdfMode} value={consult.Address} >{consult.Company}</Text>
                <Text className='invoiceTxt' pdfMode={pdfMode} value={consult.Address} >{consult.Address}</Text>
                <Text className='invoiceTxt' pdfMode={pdfMode} value={consult.City + " " + consult.St + " " + consult.Zip} >{consult.City + " " + consult.St + ", " + consult.Zip}</Text>
                <Text className='invoiceTxt' pdfMode={pdfMode} value={cons.Phone} >{cons.Phone}</Text>



              </View>
              <View className="w-50" pdfMode={pdfMode}>
                <View className="flex" pdfMode={pdfMode}>
                  <View className=" col w-100 " pdfMode={pdfMode}>
                    <View className='row flex mb-0' pdfMode={pdfMode}>
                      <View className="col text-end " pdfMode={pdfMode}>    <Text className="invoiceTxt" pdfMode={pdfMode} >{'Consultant Invoice #: '}</Text></View>
                      <View className="col   text-start " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={invoice.ConsultantInvoice} pdfMode={pdfMode} >{invoice.ConsultantInvoice}</Text></View>
                    </View>
                    <View className='row flex ' pdfMode={pdfMode}>
                      <View className="col  text-end " pdfMode={pdfMode}>    <Text className="invoiceTxt" value='Invoice #:' pdfMode={pdfMode} ></Text></View>
                      <View className="col  text-start " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={invoice.Invoice_Number} pdfMode={pdfMode} >{invoice.Invoice_Number}</Text></View>
                    </View>
                    <View className='row flex' pdfMode={pdfMode}>
                      <View className="col  text-end  " pdfMode={pdfMode}>    <Text className="invoiceTxt" value='Invoice Date:' pdfMode={pdfMode} /></View>
                      <View className="col  text-start  " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={invoice.Invoice_Date} pdfMode={pdfMode} /></View>
                    </View>
                    <View className='row flex ' pdfMode={pdfMode}>
                      <View className="col  text-end " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={'Project Name:'} pdfMode={pdfMode} /></View>
                      <View className="col   text-start " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={invoice.ProjectName} pdfMode={pdfMode} /></View>
                    </View>
                    <View className='row flex' pdfMode={pdfMode}>
                      <View className="col  text-end " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={'Project #:'} pdfMode={pdfMode} /></View>
                      <View className="col  text-start " pdfMode={pdfMode}>    <Text className="invoiceTxt" value={invoice['ConsultInv | Projects::ProjectNumber']} pdfMode={pdfMode} /></View>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <View className="flex mt-40" pdfMode={pdfMode}>
              <View className="w-50" pdfMode={pdfMode}>
                <Text className='invoiceLRI' pdfMode={pdfMode} value="LRI Consulting Services, Inc." />
                <Text className='invoiceTxt' pdfMode={pdfMode} value="P.O. Box 1529" />
                <Text className='invoiceTxt' pdfMode={pdfMode} value="Broken Arrow, OK 74013" />
                <Text className='invoiceTxt' pdfMode={pdfMode} value="(918) 455-9995" />
              </View>

              <View className="col w-50 text-center invnumCon" pdfMode={pdfMode} >
                <View className={pdfMode ? '  invoiceBox float-end   mt-5 ' : '  float-end invoiceBox'} pdfMode={pdfMode}>

                  <Text className='invoiceBoxTitle invoiceLRI ' value="Client Bill To:" pdfMode={pdfMode} />

                  <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Name} />
                  <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Title} />
                  <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Company_Name} />
                  <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.Address} />
                  <Text className='invoiceTxt' pdfMode={pdfMode} value={invoice.City + " " + invoice.State + " " + invoice.Zip}>{invoice.City + " " + invoice.State + " " + invoice.Zip}</Text>

                </View>
              </View>


            </View>
            <View className=" mt-40 w-55" pdfMode={pdfMode}>
              <Text className='input bold text-center invoiceTxt' pdfMode={pdfMode} value="Dates of Work" >Dates of Work </Text>
              <View className=" flex  text-center  " pdfMode={pdfMode}>
                <View className="flex " pdfMode={pdfMode}>

                  <Text className='input   bold invoiceTxt ' pdfMode={pdfMode}  >From: </Text>
                  <EditableInput
                    required={true}
                    type="date"
                    calendar={true}
                    className={`bold dateinput  ${!invoice.StartDate ? 'input-error' : ''}`}
                    value={invoice.StartDate}
                    onChange={(value) => handleChange('StartDate', value)}
                    pdfMode={pdfMode}
                  />
                </View>
                <View className="flex" pdfMode={pdfMode}>
                  <Text className='input  bold invoiceTxt ' pdfMode={pdfMode}   >To:</Text>
                  <EditableInput
                    required={true}
                    type="date"
                    calendar={true}
                    className={`bold dateinput ${!invoice.EndDate ? 'input-error' : ''}`}
                    value={invoice.EndDate}
                    onChange={(value) => handleChange('EndDate', value)}
                    pdfMode={pdfMode}
                  />

                </View>
              </View>
            </View>

            <View className="mt-30 bg-dark flex fs-12 " pdfMode={pdfMode}>
              <View className="w-10 text-center p-4-8" pdfMode={pdfMode}>
                <Text className="white bold invoiceTxt" pdfMode={pdfMode}>Qty</Text>
              </View>
              <View className="w-40 p-4-8 invoiceTxt" pdfMode={pdfMode}>
                <Text className="   white bold left " pdfMode={pdfMode} >Description of Service or Expense</Text>
              </View>
              <View className="w-10 p-4-8" pdfMode={pdfMode}>
                <Text className="white bold center invoiceTxt" pdfMode={pdfMode} ></Text>
              </View>
              <View className="w-20 p-4-8" pdfMode={pdfMode}>
                <Text className="white bold center invoiceTxt" pdfMode={pdfMode} >Unit Price</Text>
              </View>
              <View className="w-20 p-4-8" pdfMode={pdfMode}>
                <Text className="white bold center  invoiceTxt" pdfMode={pdfMode} >Amount</Text>
              </View>
            </View>
            {pdfMode ? null :
              dupewarn ? (<Alert className="text-center" variant="danger">
                There is a duplicate line item. Line items must be unique.
              </Alert>) : null}
            {
              invoice.lineItems.length !== undefined ? (invoice.lineItems.map((lt, i) => (
                pdfMode && lt.ProductType === '' ? (<Text key={i} pdfMode={pdfMode}></Text>) : (
                  <View key={i} className="flex rowFocu" pdfMode={pdfMode}>
                    {!pdfMode && editable && (() => {
                      const excluded = new Set([
                        "consultant - hourly",
                        "consultant - daily",
                        "consultant rate",
                        "per diem",
                        "per diem - travel day",
                        "per diem - other days",
                        "per diem - modified",
                        "mileage",
                        "travel fee",
                        "",
                        "select product or service"
                      ]);

                      const pt = (lt?.ProductType ?? "").trim().toLowerCase();

                      return pt && !excluded.has(pt) ? (
                        <ImageModal
                          info={lt}
                          onUpload={(value) => {
                            setFile(value);
                            handleProductLineChange(i, "file", value);
                          }}
                        />
                      ) : null;
                    })()}


                    <View className={pdfMode ? 'w-10 text-start' : ' w-5 p-4-8 pb-5'} pdfMode={pdfMode}>
                      <EditableInput
                        type="number"
                        placeholder="Qty"
                        value={lt.quantity}
                        readOnly={editable ? false : true}
                        className="dark right text-center invoiceTxt"
                        onChange={(value) => handleProductLineChange(i, 'quantity', value)}
                        pdfMode={pdfMode}
                      />
                    </View>

                    <View className={pdfMode ? ' w-40 ml-10' : 'w-50 p-4-8 pb-5'} pdfMode={pdfMode}>
                      {editable ? <>
                        <EditableSelect
                          placeholder="Select Product or Service"
                          options={descriptions}
                          readOnly={editable ? false : true}
                          disabled={lt.ProductDetail === "Consulting Fixed Fee Offset"}
                          onChange={(value) => {
                            handleProductLineChange(i, 'ProductType', value);
                          }}
                          value={lt.ProductType}
                          pdfMode={pdfMode}
                        />

                        {/* ✅ EditableInput only if ProductType !== Travel Fee */}

                          <EditableInput
                            // placeholder is safe even if `descripts` or the match is missing
                            placeholder={descripts?.find(d => d.value === lt.ProductType)?.placeholder ?? ""}

                            // keep the input controlled even if ProductDetail is undefined/null
                            value={lt.ProductDetail ?? ""}

                            readOnly={lt.ProductDetail === "Consulting Fixed Fee Offset"}

                            // only show error style when detail is actually required AND too short
                            className={`dark border pdfFontSize ${isDetailRequired(lt.ProductType) &&
                              (!lt.ProductDetail || lt.ProductDetail.trim().length < 3) &&
                              lt.ProductDetail !== "Reciept Required"
                              ? "input-error"
                              : ""
                              }`}

                            // IMPORTANT: keep this input in edit mode so it actually renders as an input
                            pdfMode={false}

                            onChange={(value) => {
                              handleProductLineChange(i, "ProductDetail", value);
                            }}
                          />
                       


                      </> : <>
                        <EditableInput
                          placeholder=""
                          className="dark left noHover invoiceTxt mb-0"
                          readOnly={true}
                          value={lt.ProductType}
                          pdfMode={pdfMode}
                        />
                        {lt.ProductDetail.length > 0 ? (
                          <EditableInput
                            placeholder=""
                            className="dark left noHover invoiceTxt"
                            readOnly={true}
                            value={lt.ProductDetail}
                            pdfMode={pdfMode}
                          />
                        ) : null}
                      </>}
                    </View>



                    <View className={pdfMode ? 'w-20' : 'w-17 p-4-8 pb-5'} pdfMode={pdfMode}>
                      <EditableInput
                        className="dark right noHover center pdfFontSize"
                        placeholder="Rate"
                        readOnly={lt.ProductType === 'Consultant Rate' || editable === false}
                        value={'$' + lt.rate}
                        onChange={(value) => handleProductLineChange(i, 'rate', value)}
                        onBlur={(value) => handleFormat(i, 'rate', value)}
                        pdfMode={pdfMode}
                      />
                    </View>

                    <View className={pdfMode ? 'w-20' : 'w-17 p-4-8 pb-5'} pdfMode={pdfMode}>
                      <Text className="dark right invoiceTxt" pdfMode={pdfMode}>
                        ${calculateAmount(lt.quantity, lt.rate)}
                      </Text>
                    </View>

                    {!pdfMode && editable && lt.ProductDetail !== "Consulting Fixed Fee Offset" && (
                      <button className="link row__remove" aria-label="Remove Row" title="Remove Row" onClick={() => handleRemove(i)}>
                        <span className="icon icon-remove bg-red"></span>
                      </button>
                    )}
                  </View>
                )
              ))) : (null)
            }





            <View className='row' pdfMode={pdfMode}>
              <View className="col  " pdfMode={pdfMode}>
                <View className="w-50 mt-10" pdfMode={pdfMode}>

                  {!pdfMode && (editable ? (<View className='row'> <Button variant="white" className=" ms-2 link" onClick={() => handleAdd()}>
                    <span className="iconAdd icon-add bg-green mr-10"></span>
                    Add Line Item
                  </Button></View>) : null

                  )
                  }
                </View>
              </View>
              <View className={pdfMode ? 'fs-12 ' : 'col'} pdfMode={pdfMode}>
                <View className="mt-10 float-end" pdfMode={pdfMode}>

                  <Text className=" bold right px-1" pdfMode={pdfMode} >Total</Text>

                  <Text type="number" className="right totalBox" readOnly={true} value={invoice.subTotal} placeholder="Total" onChange={(value) => handleChange('in', value)} pdfMode={pdfMode} >${invoice.subTotal}</Text>
                </View>
              </View>
            </View>



            <View className="row">

              <View className={pdfMode ? 'fs-12 ' : 'col'} pdfMode={pdfMode}>
                <View className="" pdfMode={pdfMode}>
                  <View className="row justify-content-center">
                    <View className="row d-block ">
                      <View className="w-50 mt-10 bold px-5 locationLable" pdfMode={pdfMode}>
                        <Text value='Locations' className={pdfMode ? "px-5" : "text-center"} pdfMode={pdfMode}>Locations</Text>
                      </View>
                      {invoice.locations?.length === 0 ? (<Text></Text>) : <>

                        <View className="locationContainer">

                          {invoice.locations.map((loc, i) => (
                            <View key={i} className="flex rowFocu " pdfMode={pdfMode}>
                              <View className="flex invoiceTxt " pdfMode={pdfMode}>
                                <Text className="w-10" pdfMode={pdfMode} value={i + 1} />
                                <EditableInput className={pdfMode ? "dark center" : "dark w-85  center"} placeholder="City" value={pdfMode ? invoice.locations[i].city + "," : invoice.locations[i].city} readOnly={editable ? false : true} onChange={(value) => handleLocationChange(i, 'city', value)} pdfMode={pdfMode} />
                                <EditableInput className={pdfMode ? "dark center" : "dark w-15  center"} maxLength={2} placeholder="State" value={invoice.locations[i].state.toUpperCase()} readOnly={editable ? false : true} onChange={(value) => handleLocationChange(i, 'state', value)} pdfMode={pdfMode} />
                              </View>
                              {!pdfMode && (editable ? <button className="link row__remove" aria-label="Remove Row" title="Remove Row" onClick={(value) => handleRemoveLoc(i, value)}>
                                <span className="iconLoc icon-remove bg-red"></span>
                              </button> : null)}
                            </View>
                          ))
                          }
                        </View>
                      </>
                      }


                      {invoice.locations.length <= 7 ? (!pdfMode && (editable ? <View className='row w-50 p-0'> <Button variant="white" className='bg-white link' onClick={() => handleAddLoc()}>
                        <span className="iconAdd icon-add bg-green ml-5  mr-10"></span>
                        Add Location
                      </Button></View> : null)) : null}

                    </View>
                    <View className={pdfMode ? 'row' : " flex row"} pdfMode={pdfMode}>
                      <View className="w-70 mt-10 bold row" pdfMode={pdfMode}>
                        <Text className={pdfMode ? " px-5   " : "text-center  locationLable notes "} pdfMode={pdfMode}>Notes</Text>
                        <EditableTextarea className="w-100 invoiceTxt notesBox" rows={3} readOnly={editable ? false : true} value={invoice.ConsultantNotes} onChange={(value) => handleChange('ConsultantNotes', value)} pdfMode={pdfMode} />
                      </View>
                      <View className={pdfMode ? 'w-30 mt-10 bold floatleft' : "w-30 mt-10 bold "} pdfMode={pdfMode}>
                        <Text className={pdfMode ? "mb-0 fs-12" : "text-center mb-0 fs-12"} value='Reportable' pdfMode={pdfMode}>Reportable</Text>
                        {editable ? <EditableSelect className={pdfMode ? "w-100 border border-light-subtle border-3 " : `w-100  text-center border border-light-subtle border-3  ${!invoice.Reportable || invoice.Reportable.length < 1 ? "input-error" : ""}`} value={invoice.Reportable} options={reportable} onChange={(value) => handleChange('Reportable', value)} pdfMode={pdfMode} /> :

                          <EditableInput placeholder="" className={pdfMode ? " invoiceTxt  border border-light-subtle border-3" : `dark left noHover invoiceTxt text-center  border border-light-subtle border-3 `} readOnly={true} value={invoice.Reportable === "Reportable" ? 'Yes' : 'No'} pdfMode={pdfMode} />
                        }

                      </View>
                    </View>
                  </View>
                </View>
              </View>



            </View>

          </Page>
          {pdfMode ? null : (
            <Container>
              <Row className="justify-content-center mt-3 d-flex">

                {(() => {
                  const draftInvalid = checkForm("draft");
                  const submitInvalid = checkForm("submit");

                  return editable ? (
                    draftInvalid ? (
                      <p className="text-danger text-center">
                        Please fill in all required fields: <strong>Dates Worked, Invoice #, Line Items, and Reportable</strong>.
                       <br /> <strong>Each line item description must be at least 3 characters.</strong>
                        <br />To submit, you’ll also need to provide a <strong>Location</strong> (City &amp; State).
                      </p>
                    ) : submitInvalid ? (
                      <p className="text-danger text-center">
                        You can <strong>save a draft</strong> now. To <strong>submit</strong>, please add a <strong>Location</strong> (City &amp; State required).
                      </p>
                    ) : null
                  ) : null;
                })()}

                {alertShow ? (
                  <>
                    <Row className="justify-content-center d-flex">
                      <AlertMsg message={alertMsg} vari={alertVari} title={alertTitle} />
                    </Row>
                  </>
                ) : null}

                {!btnSelect ? (
                  <Row className="justify-content-center d-flex">
                  <Col sm className="justify-content-center d-flex my-2">
                    {!pdfMode && (
                      <Button style={{ width: "150px" }} variant="primary">
                        <DownloadPDF fileName={invoice.Company_Name + "-" + invoice.Invoice_Number} data={invoice} />
                      </Button>
                    )}
                  </Col>
                  {invoice.Status === 'Processed' ? ( 
                  <Col sm className="justify-content-center d-flex my-2">
                    {!pdfMode && (
                      <Button style={{ width: "150px" }} variant="success">
                      
                        <ExportCSV filenamePrefix={invoice.Company_Name + "-" + invoice.Invoice_Number}  record={data} />
                      </Button>
                    )}
                  </Col>
                  ) : null}
                  </Row>
                ) : null}

                {!btnSelect ? null : (
                  <>
                    <Col sm className="justify-content-center d-flex my-2">
                      {!pdfMode && (
                        <Confirm
                          headingTxt="Save Draft Confirmation"
                          disabled={checkForm("draft")}
                          onConfirm={(e) => handleDraft(e)}
                          bodyMsg={`Confirm you want to save a draft invoice for  ${invoice.Company_Name}.`}
                          action="Save Draft"
                          vari="success"
                        />
                      )}
                    </Col>

                    <Col sm className="justify-content-center d-flex my-2">
                      {!pdfMode && (
                        <Confirm
                          headingTxt="Submit Invoice Confirmation"
                          disabled={checkForm("submit")}
                          onConfirm={(e) => handleSubmit(e)}
                          bodyMsg={`Confirm you want to submit an invoice for ${invoice.Company_Name}. You will not be able to edit this invoice later. `}
                          action="Submit Invoice"
                          vari="primary"
                        />
                      )}
                    </Col>
                  </>
                )}
              </Row>
            </Container>
          )}

        </Document>

      </>
    )
    }



  </>
  )
}


export default Invoice
